"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ListingList_1 = require("./ListingList");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ListingTile_1 = require("./ListingTile");
var ListingBookmarks = /** @class */ (function (_super) {
    __extends(ListingBookmarks, _super);
    function ListingBookmarks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderListing = function (listing, idx, props) {
            return React.createElement(ListingTile_1.ListingTile, { key: listing.id, listing: listing, styles: { root: { height: 200, minHeight: 200 } }, onClick: props.onSelectItem });
        };
        return _this;
    }
    ListingBookmarks.prototype.render = function () {
        if (this.props.bookmarkList.value && this.props.bookmarkList.value.length > 0) {
            var listings = this.props.bookmarkList.value.map(function (bookmark) { return bookmark.listing; });
            return React.createElement(ListingList_1.ListingList, { listings: listings, onSelectItem: this.props.onSelectListing, compact: true, wrapping: true, onRenderListing: this._onRenderListing });
        }
        return this.props.onRenderNoBookmarks ? this.props.onRenderNoBookmarks() :
            (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.warning }, "You haven't bookmarked anything."));
    };
    ListingBookmarks = __decorate([
        mobx_react_1.observer
    ], ListingBookmarks);
    return ListingBookmarks;
}(React.Component));
exports.ListingBookmarks = ListingBookmarks;
var ListingBookmarksContainer = /** @class */ (function (_super) {
    __extends(ListingBookmarksContainer, _super);
    function ListingBookmarksContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingBookmarks, __assign({}, _this.props));
        };
        return _this;
    }
    ListingBookmarksContainer.prototype.componentWillMount = function () {
        this.props.bookmarkList.load();
    };
    ListingBookmarksContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.bookmarkList.sync, onRenderDone: this._onRenderDone });
    };
    return ListingBookmarksContainer;
}(React.Component));
exports.ListingBookmarksContainer = ListingBookmarksContainer;
